export enum MessageLevel { INFO = "INFO", WARNING = "WARNING", ERROR = "ERROR" };

export class RiserUploadResponse {

  messageLevel!: MessageLevel;
  messages!: string[];

}
